import {CloudUpload} from '@mui/icons-material';

import ProjectMenuImportDataButton from './ProjectMenuImportDataButton';
import useProjectCrudModal from '../../../../../hooks/dom/useProjectCrudModal';
import useUpload from '../../../../../hooks/providers/useUpload';
import {projectShape} from '../../../../../proptypes-shapes';
import ProjectActionButton from '../ProjectActionButton';

const ImportProjectDataButton = ({project}) => {
  const {setProjectSelected, setIsUploadFilesModalOpen} = useUpload();
  const {openModal} = useProjectCrudModal({setModalOpen: setIsUploadFilesModalOpen, project});

  const handleOpen = openModalFunction => {
    setProjectSelected(project);
    openModalFunction();
  };

  return (
    <ProjectActionButton cardMarkup={<ProjectMenuImportDataButton />} listMarkup={<CloudUpload sx={{cursor: 'pointer'}} fontSize="small" color="primary" onClick={() => handleOpen(openModal)} />} />
  );
};

ImportProjectDataButton.propTypes = {
  project: projectShape
};

export default ImportProjectDataButton;
